<template>
  <ve-ring :data="chartData" :settings="chartSettings" :width='width' :height='height' :extend="extend" :events='chartEvents'></ve-ring>
</template>

<script>
  export default {
     props:{
      chartSettings:Object,
      chartData:Object,
      height:String,
      width:String,
      extend:Object

  },
   mounted() {
      self=this
    },
    data () {
       this.chartEvents = {
        click: function (e) {
          self.$emit('click',{value:e})
        }
      }
      return {
        
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/chart/RingBar.vue